import React from 'react';

import { NotFoundTable, ProductTableProps } from '../DynamicProductTable/constants';

import { CheckingAccountTable } from './checking-account';
import { ClubesTable } from './clubes';
import { CoesTable } from './coes';
import { DirectTreasuryTable } from './direct-treasury';
import { EquityTable } from './equity';
import { FixedIncomeTable } from './fixed-income';
import { FundsTable } from './funds';
import { PrivatePensionTable } from './private-pension';

export const ProductTable = (props: ProductTableProps) => {
  const renderTableByProductType = () => {
    switch (props.product.productClassName) {
      case 'OPERACAO_ESTRUTURADA':
        return <CoesTable {...props} />;

      case 'PREVIDENCIA':
        return <PrivatePensionTable {...props} />;

      case 'FUNDO':
        return <FundsTable {...props} />;

      case 'RENDA_FIXA':
        return <FixedIncomeTable {...props} />;

      case 'TESOURO_DIRETO':
        return <DirectTreasuryTable {...props} />;

      case 'RENDA_VARIAVEL':
        return <EquityTable {...props} />;

      case 'CLUBES':
        return <ClubesTable {...props} />;

      case 'checking-account':
        return <CheckingAccountTable {...props} />;

      default:
        return <NotFoundTable />;
    }
  };

  return renderTableByProductType();
};
